import { render, staticRenderFns } from "./DialogCouponDetail.pug?vue&type=template&id=31545822&scoped=true&lang=pug&"
import script from "./DialogCouponDetail.vue?vue&type=script&lang=js&"
export * from "./DialogCouponDetail.vue?vue&type=script&lang=js&"
import style0 from "./DialogCouponDetail.scss?vue&type=style&index=0&id=31545822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31545822",
  null
  
)

export default component.exports